import type { Story } from '@/store/story-types'

export const K_BEAUTY_STORE_STORY: Story = {
  id: 'k-beauty-store',
  name: 'GLOWHAUS — K-Beauty Store',
  narrative: 'A K-Beauty store featuring ingredient-focused products, skin-care routines, ratings, cart management, and global shipping checkout.',
  goals: ['Browse K-beauty products', 'View ingredient details', 'Build skin-care routines', 'Add to cart and checkout'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Landing page with navbar, hero banner, bestsellers grid, routine builder, and footer',
      blockRef: { category: 'k-commerce', blockId: 'kb-hero' },
    },
    {
      id: 'pg-product-detail', title: 'Product Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'product-detail',
      description: 'Product detail page with images, ingredients, reviews, and add-to-cart action',
      blockRef: { category: 'k-commerce', blockId: 'kb-product-detail' },
    },
    {
      id: 'pg-products', title: 'All Products', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'products',
      description: 'Full product listing with filters and sorting',
      blockRef: { category: 'k-commerce', blockId: 'kb-bestsellers' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Shopping bag with item list, quantity controls, and subtotal',
      blockRef: { category: 'k-commerce', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout', title: 'Checkout', order: 4, status: 'draft', elementCount: 3, linkedPageId: 'checkout',
      description: 'Checkout form with shipping address, payment, and order confirmation',
      blockRef: { category: 'k-commerce', blockId: 'kb-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Bestsellers',
      description: 'Visitor browses K-beauty bestseller products on the home page',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner, bestseller grid, and routine builder section are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Product Detail',
      description: 'Visitor views a specific product with ingredients and reviews',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail page shows images, ingredient list, ratings, and an add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add to Cart',
      description: 'Visitor adds a product to the shopping bag',
      steps: [
        { type: 'given', text: 'the visitor is on the product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap the Add to Bag button' },
        { type: 'then', text: 'the cart badge updates and the item appears in the cart', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Complete Checkout',
      description: 'Visitor completes the checkout flow with shipping and payment',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout' },
        { type: 'then', text: 'a checkout form with shipping address and payment fields is displayed', linkedPageId: 'checkout' },
        { type: 'and', text: 'the form validates inputs before order submission', linkedFlowId: 'validateCheckout' },
      ],
    },
  ],
}
